import { useState } from "react";

import Modal from "components/Modal";
import ModalBody from "components/Modal/ModalBody";
import ModalFooter from "components/Modal/ModalFooter";
import useTranslation from "hooks/useTranslation";

function ConfirmModal({
  setShowModal,
  showModal,
  text,
  showAgainOption = false,
  popupId,
  handleConfirm,
}) {
  const { getTranslation } = useTranslation("COMMON");
  const [notShowPopupAgain, setNotShowPopupAgain] = useState(false);
  const { t } = getTranslation();

  const handleConfirmBtnClick = () => {
    const status = notShowPopupAgain ? "never" : false;

    handleConfirm();

    const obj = { status, id: popupId };
    const stringifiedObj = JSON.stringify(obj);
    localStorage.setItem(popupId, stringifiedObj);

    setShowModal(false);
  };
  const handleDenyBtnClick = () => {
    setShowModal(false);
  };

  const handleChangePopupDisplay = () => {
    setNotShowPopupAgain((prev) => !prev);
  };

  const renderShowAgainOption = showAgainOption && (
    <span>
      <input
        type="checkbox"
        checked={notShowPopupAgain}
        onChange={handleChangePopupDisplay}
        id="text"
      />
      <label aria-labelledby="label" htmlFor="text">
        {t("DO_NOT_SHOW_MSG_AGAIN")}
      </label>
    </span>
  );

  return (
    <Modal
      setVisibility={setShowModal}
      visible={showModal}
      className="confirmation-modal"
    >
      <ModalBody>
        <div>
          <div className="conv__body__header_block_user_modal_title">
            {text}
          </div>
        </div>
        {renderShowAgainOption}
      </ModalBody>
      <ModalFooter>
        <div className="modal__container__footer__left">
          <button
            onClick={handleDenyBtnClick}
            className="btn btn-tertiary"
            id="closeModal"
          >
            {t("MODAL").CANCEL}
          </button>
          <button onClick={handleConfirmBtnClick} className="btn btn-primary">
            {t("MODAL").CONFIRM}
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default ConfirmModal;
